import ConfigService from 'client/util/ConfigService';
import axios from 'axios';

/**
 * @typedef {Object} JCStatusResponse - Status response from JC api
 * @property {object} status
 * @property {string} status.description - Detailed discription of the status
 * @property {string} status.indicator - 'none' | 'minor' | 'major' | 'critical' | 'maintenance'
 */
export class StatusApi {
  loadBaseUrl() {
    this.statusUrl = ConfigService.jcStatusUrl;
  }

  /**
   * @returns {JCStatusResponse}
   * @throws Will throw an error if the url is null.
   */
  async getStatus() {
    this.loadBaseUrl();
    let response;
    if (this.statusUrl) {
      response = await axios.get(`${this.statusUrl}/api/v2/status.json`);
    } else {
      throw new Error(404);
    }
    return response.data;
  }
}

export default new StatusApi();
